import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=34c55005&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=34c55005&prod&lang=scss&scoped=true"
import style1 from "./OrderStatus.vue?vue&type=style&index=1&id=34c55005&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c55005",
  null
  
)

/* custom blocks */
import block0 from "@/locales2/share/ratingValue.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fsrc%2Fapp%2Fsrc%2Fcomponents%2Frecord_detail_v2%2FOrderStatus.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports